import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41f6dacc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.2959 7.11895C18.6864 6.72842 18.6864 6.09526 18.2959 5.70473C17.9054 5.31421 17.2722 5.31421 16.8817 5.70473L12.0003 10.5861L7.11895 5.70473C6.72842 5.31421 6.09526 5.31421 5.70473 5.70473C5.31421 6.09526 5.31421 6.72842 5.70473 7.11895L10.5861 12.0003L5.70473 16.8817C5.31421 17.2722 5.31421 17.9054 5.70473 18.2959C6.09526 18.6864 6.72842 18.6864 7.11895 18.2959L12.0003 13.4145L16.8817 18.2959C17.2722 18.6864 17.9054 18.6864 18.2959 18.2959C18.6864 17.9054 18.6864 17.2722 18.2959 16.8817L13.4145 12.0003L18.2959 7.11895Z",
    fill: "white"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "frisbuy-mobile-popup__header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Все фото покупателей", -1))
const _hoisted_5 = {
  key: 0,
  class: "frisbuy-mobile-popup__swipe-hint",
  "aria-hidden": "true"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-mobile-popup__swipe-hint-block" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["src", "onError"]
const _hoisted_9 = ["src", "onError"]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "24",
    cy: "24",
    r: "16",
    fill: "#212121",
    "fill-opacity": "0.2"
  }),
  /*#__PURE__*/_createElementVNode("g", { opacity: "0.8" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M28.1192 22.7772C28.8701 23.2446 28.8701 24.4239 28.1192 24.8912L22.6451 28.2979C21.8999 28.7616 20.9727 28.1756 20.9727 27.2409L20.9727 20.4276C20.9727 19.4928 21.8999 18.9068 22.6451 19.3706L28.1192 22.7772Z",
      fill: "white"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M34.125 24.0005C34.125 18.4083 29.5921 13.8744 24 13.8742C18.4076 13.8742 13.8737 18.4081 13.8737 24.0005C13.8739 29.5926 18.4078 34.1255 24 34.1255C29.592 34.1252 34.1248 29.5925 34.125 24.0005ZM36.7917 24.0005C36.7914 31.0652 31.0647 36.7919 24 36.7922C16.935 36.7922 11.2073 31.0654 11.207 24.0005C11.207 16.9354 16.9349 11.2075 24 11.2075C31.0649 11.2078 36.7917 16.9355 36.7917 24.0005Z",
      fill: "white"
    })
  ])
], -1))
const _hoisted_12 = [
  _hoisted_11
]

import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import CustomerReview from "../CustomerReview.vue";
import MobileReviewSheet from "../MobileReviewSheet.vue";
import PopupReviewMobileMediaSlider from "../PopupReviewMobileMediaSlider.vue";
import PopupReviewMobileVideoControls from "./PopupReviewMobileVideoControls.vue";
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
import widgetTypes from "@/common/consts/widgetTypes";
import { imageWithPostId, IMarketplaceReviewsPost } from "../../interfaces";

const SWIPE_HINT_DURATION_MS = 2880;

export default /*#__PURE__*/_defineComponent({
  __name: 'PopupReviewPostMobile',
  props: {
    post: {},
    selectedPostIndex: {},
    selectedMediaIndex: {},
    bestPostIds: {},
    allCustomersMediaList: {},
    totalMediaCount: {},
    reviewDate: {},
    reviewTime: {}
  },
  emits: [
  "close",
  "selectPrevPost",
  "selectNextPost",
  "selectPost",
  "sendAnaliticEvent",
  "requestToLoadCustomersMedia",
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isMobileReviewSheetOpen = ref(false);
const isVideoPlaying = ref(false);
const isVideoInterfaceVisible = ref(false);
const videoElements = ref<(HTMLVideoElement | null)[]>([]);
const swiperInstance = ref<any | null>(null);
const slideImageFallbackSteps = ref<Record<string, number>>({});
const activeSlideIndex = ref(0);
const showSwipeHint = ref(false);
let swipeHintTimer: ReturnType<typeof setTimeout> | null = null;
const swiperMediaList = computed<imageWithPostId[]>(() => {
  if (props.allCustomersMediaList.length) {
    return props.allCustomersMediaList;
  }

  const postId =
    props.post.instagramPost?.frisbuyId || props.post.providerPost?.frisbuyId;
  return props.post.media.map((media) => ({
    ...media,
    postId,
  }));
});

const currentMediaIndex = computed(() => {
  const postId =
    props.post.instagramPost?.frisbuyId || props.post.providerPost?.frisbuyId;
  const currentMedia = props.post.media[props.selectedMediaIndex];

  return swiperMediaList.value.findIndex((media) => {
    return media.postId === postId && media.imageUrl === currentMedia?.imageUrl;
  });
});

const mediaCounterText = computed(() => {
  const totalMediaCount = props.totalMediaCount ?? swiperMediaList.value.length;

  if (!totalMediaCount) {
    return "0/0";
  }

  const normalizedIndex =
    currentMediaIndex.value < 0 ? 0 : currentMediaIndex.value + 1;
  return `${normalizedIndex}/${totalMediaCount}`;
});
const initialSlide = computed(() =>
  currentMediaIndex.value < 0 ? 0 : currentMediaIndex.value
);

const currentMedia = computed<imageWithPostId>(() => {
  const postMedia = props.post.media[props.selectedMediaIndex];
  return {
    ...postMedia,
    postId:
      props.post.instagramPost?.frisbuyId || props.post.providerPost?.frisbuyId,
  };
});

const reviewText = computed(() => props.post.frisbuyPost.text?.trim() || "");
const isVideoMode = computed(
  () => isVideoInterfaceVisible.value && Boolean(currentMedia.value.videoUrl)
);

watch(
  () => [props.post, props.selectedMediaIndex],
  () => {
    isVideoInterfaceVisible.value =
      isVideoInterfaceVisible.value && Boolean(currentMedia.value.videoUrl);
    isVideoPlaying.value =
      isVideoPlaying.value && Boolean(currentMedia.value.videoUrl);
    slideImageFallbackSteps.value = {};

    const targetSlide =
      currentMediaIndex.value < 0 ? 0 : currentMediaIndex.value;
    if (
      swiperInstance.value &&
      swiperInstance.value.activeIndex !== targetSlide
    ) {
      swiperInstance.value.slideTo(targetSlide, 0);
    }
  }
);

function getImageCandidateByStep(media: imageWithPostId, step: number) {
  const candidates = [
    media.imageHighResolutionUrl,
    media.imageUrl,
    media.thumbnailUrl,
  ].filter(Boolean);

  return candidates[step] || "";
}

function getMediaKey(media: imageWithPostId, index: number) {
  return `${media.postId}-${media.thumbnailUrl || media.imageUrl || index}`;
}

function getSlideImage(media: imageWithPostId, index: number) {
  const key = getMediaKey(media, index);
  const step = slideImageFallbackSteps.value[key] || 0;
  return getImageCandidateByStep(media, step);
}

function onSwiperInit(swiper: any) {
  swiperInstance.value = swiper;
  activeSlideIndex.value = swiper.activeIndex || 0;
}

function onSlideChange(swiper: any) {
  activeSlideIndex.value = swiper.activeIndex || 0;
  const selectedMedia = swiperMediaList.value[swiper.activeIndex];
  if (!selectedMedia) return;

  if (isVideoInterfaceVisible.value) {
    pauseAndResetAllVideos();
    const hasVideo = Boolean(selectedMedia.videoUrl);
    isVideoInterfaceVisible.value = hasVideo;
    isVideoPlaying.value = hasVideo;

    if (hasVideo) {
      const nextVideo = getActiveVideoElement();
      nextVideo?.play().catch(() => {
        isVideoPlaying.value = false;
      });
    }
  }

  emit("selectPost", selectedMedia.postId, selectedMedia);
}

function closePopup() {
  emit("close");
}

function selectMedia(media: imageWithPostId) {
  if (isVideoPlaying.value) {
    stopVideo();
  }

  emit("selectPost", media.postId, media);
}

function playVideo() {
  const activeVideo = getActiveVideoElement();
  if (!activeVideo) return;

  emit("sendAnaliticEvent", "PlayVideo", {
    provPostId:
      props.post.instagramPost?.frisbuyId ?? props.post.providerPost.frisbuyId,
    fbProduct: props.post.frisbuyPost.id,
    igCode: props.post.instagramPost.shortcode,
  });

  isVideoInterfaceVisible.value = true;
  isVideoPlaying.value = true;
  activeVideo.currentTime = 0;
  activeVideo.play().catch(() => {
    isVideoPlaying.value = false;
  });
}

function resumeVideo() {
  const activeVideo = getActiveVideoElement();
  if (!activeVideo) return;

  isVideoInterfaceVisible.value = true;
  activeVideo.play().then(() => {
    isVideoPlaying.value = true;
  }).catch(() => {
    isVideoPlaying.value = false;
  });
}

function toggleVideoPlayback() {
  const activeVideo = getActiveVideoElement();
  if (!activeVideo || !isVideoInterfaceVisible.value) {
    return;
  }

  if (isVideoPlaying.value) {
    activeVideo.pause();
    return;
  }

  resumeVideo();
}

function onMediaSlideClick(media: imageWithPostId, index: number) {
  if (!media.videoUrl || activeSlideIndex.value !== index) {
    return;
  }

  if (!isVideoInterfaceVisible.value) {
    playVideo();
    return;
  }

  if (isVideoPlaying.value) {
    toggleVideoPlayback();
    return;
  }

  resumeVideo();
}

function pauseVideo() {
  isVideoPlaying.value = false;
}

function stopVideo() {
  isVideoPlaying.value = false;
  isVideoInterfaceVisible.value = false;
  pauseAndResetAllVideos();
}

function pauseAndResetAllVideos() {
  videoElements.value.forEach((video) => {
    if (!video) return;
    video.pause();
    video.currentTime = 0;
  });
}

function setVideoRef(el: HTMLVideoElement | null, index: number) {
  videoElements.value[index] = el;
}

function getActiveVideoElement() {
  return videoElements.value[activeSlideIndex.value] || null;
}

function lockWindowScroll() {
  document.documentElement.style.overflow = "hidden";
}

function unlockWindowScroll() {
  document.documentElement.style.overflow = "";
}

onMounted(() => {
  lockWindowScroll();
  slideImageFallbackSteps.value = {};
  activeSlideIndex.value = initialSlide.value;
  showSwipeHint.value = true;
  swipeHintTimer = setTimeout(() => {
    showSwipeHint.value = false;
  }, SWIPE_HINT_DURATION_MS);
});

onBeforeUnmount(() => {
  if (swipeHintTimer) {
    clearTimeout(swipeHintTimer);
    swipeHintTimer = null;
  }
  unlockWindowScroll();
});

function errorSlideImageHandler(
  e: Event,
  media: imageWithPostId,
  index: number
) {
  const key = getMediaKey(media, index);
  const nextStep = (slideImageFallbackSteps.value[key] || 0) + 1;
  const nextImage = getImageCandidateByStep(media, nextStep);
  if (nextImage) {
    slideImageFallbackSteps.value = {
      ...slideImageFallbackSteps.value,
      [key]: nextStep,
    };
    return;
  }

  MediaCatcher(e, 2, widgetTypes.STORY);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["frisbuy-mobile-popup", { 'frisbuy-mobile-popup--video-mode': isVideoMode.value }]),
      onClick: _withModifiers(closePopup, ["self"])
    }, [
      _createElementVNode("button", {
        class: "frisbuy-mobile-popup__close",
        type: "button",
        onClick: closePopup
      }, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(mediaCounterText.value), 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["frisbuy-mobile-popup__media", { 'frisbuy-mobile-popup__media--video': isVideoMode.value }])
      }, [
        (showSwipeHint.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true),
        _createVNode(_unref(Swiper), {
          class: "frisbuy-mobile-popup__swiper",
          "initial-slide": initialSlide.value,
          onSwiper: onSwiperInit,
          onSlideChange: onSlideChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(swiperMediaList.value, (media, index) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                key: `${media.postId}-${
              media.thumbnailUrl || media.imageUrl || index
            }`,
                class: "frisbuy-mobile-popup__slide",
                onClick: ($event: any) => (onMediaSlideClick(media, index))
              }, {
                default: _withCtx(() => [
                  (!media.videoUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(DomainSubstitute)(getSlideImage(media, index)),
                        onError: (e) => errorSlideImageHandler(e, media, index)
                      }, null, 40, _hoisted_8))
                    : (!isVideoPlaying.value || activeSlideIndex.value !== index)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _unref(DomainSubstitute)(getSlideImage(media, index)),
                          onError: (e) => errorSlideImageHandler(e, media, index)
                        }, null, 40, _hoisted_9))
                      : _createCommentVNode("", true),
                  (media.videoUrl)
                    ? _withDirectives((_openBlock(), _createElementBlock("video", {
                        key: 2,
                        src: media.videoUrl,
                        muted: "",
                        loop: "true",
                        playsinline: "",
                        ref_for: true,
                        ref: (el) => setVideoRef(el as HTMLVideoElement | null, index),
                        onClick: _withModifiers(toggleVideoPlayback, ["stop"]),
                        onPause: pauseVideo
                      }, null, 40, _hoisted_10)), [
                        [_vShow, isVideoInterfaceVisible.value && activeSlideIndex.value === index]
                      ])
                    : _createCommentVNode("", true),
                  (media.videoUrl && (!isVideoInterfaceVisible.value || !isVideoPlaying.value))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 3,
                        class: "frisbuy-mobile-popup__play-icon",
                        onClick: _withModifiers(playVideo, ["stop"])
                      }, _hoisted_12))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["initial-slide"]),
        _createElementVNode("div", {
          class: _normalizeClass(["frisbuy-mobile-popup__video-overlay", { 'frisbuy-mobile-popup__video-overlay--video': isVideoMode.value }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["frisbuy-mobile-popup__info", { 'frisbuy-mobile-popup__info--video': isVideoMode.value }])
          }, [
            _createVNode(CustomerReview, {
              customerName: 
                props.post.instagramPost.authorUser.fio ||
                `@${props.post.instagramPost.authorUser.username}`
              ,
              reviewDate: props.reviewDate,
              reviewTime: props.reviewTime,
              rating: props.post.frisbuyPost.rating,
              negativeComment: '',
              positiveComment: '',
              text: reviewText.value,
              isShowMedia: false,
              authorView: "popup",
              sectionsMarginTop: ['0', '20px', '30px']
            }, {
              topRight: _withCtx(() => [
                _createElementVNode("button", {
                  class: "frisbuy-mobile-popup__open-review",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isMobileReviewSheetOpen.value = true))
                }, " См. отзыв ")
              ]),
              _: 1
            }, 8, ["customerName", "reviewDate", "reviewTime", "rating", "text"])
          ], 2),
          (isVideoMode.value)
            ? (_openBlock(), _createBlock(PopupReviewMobileVideoControls, {
                key: 0,
                videoEl: getActiveVideoElement()
              }, null, 8, ["videoEl"]))
            : _createCommentVNode("", true)
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["frisbuy-mobile-popup__bottom-layer", { 'frisbuy-mobile-popup__bottom-layer--video': isVideoMode.value }])
      }, [
        _withDirectives(_createVNode(PopupReviewMobileMediaSlider, {
          mediaList: props.allCustomersMediaList,
          selectedMediaThumbnailUrl: currentMedia.value?.thumbnailUrl,
          onSelectMedia: _cache[1] || (_cache[1] = (media) => selectMedia(media)),
          onRequestToLoadCustomersMedia: _cache[2] || (_cache[2] = ($event: any) => (emit('requestToLoadCustomersMedia')))
        }, null, 8, ["mediaList", "selectedMediaThumbnailUrl"]), [
          [_vShow, !isVideoMode.value]
        ])
      ], 2),
      _createVNode(MobileReviewSheet, {
        isOpen: isMobileReviewSheetOpen.value,
        post: props.post,
        bestPostIds: props.bestPostIds,
        reviewIndex: props.selectedPostIndex + 1,
        reviewDate: props.reviewDate,
        selectedMediaThumbnailUrl: currentMedia.value?.thumbnailUrl,
        mediaList: props.allCustomersMediaList,
        onClose: _cache[3] || (_cache[3] = ($event: any) => (isMobileReviewSheetOpen.value = false)),
        onSelectMedia: _cache[4] || (_cache[4] = (media) => selectMedia(media))
      }, null, 8, ["isOpen", "post", "bestPostIds", "reviewIndex", "reviewDate", "selectedMediaThumbnailUrl", "mediaList"])
    ], 2)
  ]))
}
}

})